import React, { useState } from "react";
import { toast } from "sonner";
import { GlobeHemisphereWest } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AdminModal, errText } from "@/components/pageSettings/AdminModal";
import { landerSettings } from "@/lib/landerDomain";
import { DomainCheckResults } from "./DomainCheckResults";

const BTN = "border-2 border-black bg-white px-2 py-1 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 transition-colors duration-100 hover:bg-black hover:text-white disabled:opacity-40";

// One tap: open these buyer pages on the landing domain and confirm their thank-you page and delivery.
export function DomainCheckButton({ body = {}, label, testId = "domain-check", onDone, className = BTN }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const domain = landerSettings()?.domain || "the landing domain";
  const run = async () => {
    setOpen(true);
    setBusy(true);
    setData(null);
    try {
      const { data: r } = await api.post("/admin/domain-check", body);
      setData(r);
      onDone?.(r);
    } catch (e) {
      toast.error(errText(e, "Couldn't run the check"));
      setOpen(false);
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <button type="button" onClick={run} disabled={busy} className={className} data-testid={testId}>
        <GlobeHemisphereWest size={11} weight="bold" /> {busy ? "Checking…" : label || `Check on ${domain}`}
      </button>
      {open && (
        <AdminModal eyebrow="Landing domain check" title={`Buyer pages on ${domain}`} onClose={() => setOpen(false)} testId={`${testId}-modal`} wide>
          {busy && <div className="label-mono p-6 text-center" data-testid={`${testId}-loading`}>Opening each page on {domain}…</div>}
          {data && <DomainCheckResults data={data} canTest={["super_admin", "admin"].includes(user?.role)} />}
        </AdminModal>
      )}
    </>
  );
}
